import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { _baseUrl, _sentrackBaseUrl } from '../../helper/global-helper';
import { BasicMachineFunctionsService } from '../basicMachineFunctions/basic-machine-functions.service';

@Injectable({
    providedIn: 'root',
})
export class DtcRetrievalService {
    dtcsLoaded: Map<number, boolean> = new Map();
    dtcs: J1939DtcBase[] = [];
    private baseUrl: string;
    private sentrackUrl: string;

    constructor(private http: HttpClient, private machineService: BasicMachineFunctionsService) {
        this.baseUrl = _baseUrl;
        this.sentrackUrl = _sentrackBaseUrl;
    }

    public getDtcsByStatusMask(ecuId: number, subfuntionType: number, statusMask: number, initialRequest: boolean) {
        return this.http
            .get<J1939DtcBase[]>(
                this.baseUrl +
                    'dtc?ecuid=' + ecuId +
                    '&subfunctiontype=' + subfuntionType +
                    '&statusmask=' + statusMask +
                    '&initialrequest=' + initialRequest,
                {
                    observe: 'response',
                    responseType: 'json',
                }
            );
    }

    public getDtcsAfterLoading(ecuId: number, subfuntionType: number, statusMask: number) {
        return this.http
            .get<J1939DtcBase[]>(
                this.baseUrl +
                    'dtc?ecuid=' + ecuId +
                    '&subfunctiontype=' + subfuntionType +
                    '&statusmask=' + statusMask +
                    '&initialrequest=false',
                {
                    observe: 'response',
                    responseType: 'json',
                }
            );
    }

    public getDtcsWithTimestamp(ecuId: number, subfuntionType: number, recordNumber: number, initialRequest: boolean) {
        return this.http
            .get<J1939DtcBase[]>(
                this.baseUrl +
                    'dtc?ecuid=' + ecuId +
                    '&subfunctiontype=' + subfuntionType + //evtl hardgecoded 22
                    '&recordnumber=' + recordNumber +
                    '&initialrequest=' + initialRequest,
                {
                    observe: 'response',
                    responseType: 'json',
                }
            );
    }

    public getDtcsWithTimestampAfterLoading(ecuId: number, subfuntionType: number, recordNumber: number) {
        return this.http
            .get<J1939DtcBase[]>(
                this.baseUrl +
                    'dtc?ecuid=' + ecuId +
                    '&subfunctiontype=' + subfuntionType +
                    '&recordnumber=' + recordNumber +
                    '&initialrequest=false',
                {
                    observe: 'response',
                    responseType: 'json',
                }
            );
    }

    /*
    type: "fmi", "spn", "dtc" - For FMI, no ecu id is neccessary. Meanings:
        FMI: FMI to text mapping,
        SPN: SPN to Parameter Name mapping
        DTC: Full DTC Mapping with Consequences and suggestions

    ecuId: ecuId
    language: languagecode (later necessary when translation files exist)
    */
    public getMappingFiles(type: string, ecuId: number, line: string, language?: string) {
        if(language == undefined){
            language = 'en'
        }
        return this.http.get(this.baseUrl + "dtcmapping?type=" + type + "&lang=" + language + "&ecuid=" + ecuId.toString() + '&productline=' + line + 'line', {
            observe: 'response',
            responseType: 'json',
        });
    }

    public checkTroubleshooterAvailable(machineType: string, source: string, spn: string, fmi: string, machineSeries: string): Promise<{status: boolean, res: any}> {
        return new Promise<{status: boolean, res: any}>((resolve) => {
            let ans;
            this.machineService.getExchangeToken().subscribe((res) => {
                let response = JSON.parse(JSON.stringify(res.body));
                this.fetchTroubleshooter(machineType, source, spn, fmi, machineSeries, response.access_token).subscribe((resp) => {
                    if(resp.status == 404){
                        ans = {status: false, res: ''};
                        resolve(ans);
                    } else {
                        ans = {status: true, res: resp.body};
                        resolve(ans);
                    }
                });
            });
        }).then((value) => {
            return value;
        });   
    }
// TEST: https://sentrack.sennebogen.com/api/client-sennebogen-business-service/troubleshooter?machineType=840&source=123&spn=516677&fmi=5&machineSeries=E
// https://sentrack.sennebogen.com/api/client-sennebogen-business-service/troubleshooter?machineType=" + machineType + "&source=" + source + "&spn=" + spn + "&fmi=" + fmi + "&machineSeries="+ machineSeries
    private fetchTroubleshooter(machineType: string, source: string, spn: string, fmi: string, machineSeries: string, token: string) {
        let headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
        return this.http.get(this.sentrackUrl + "/client-sennebogen-business-service/troubleshooter?machineType=" + machineType + "&source=" + source + "&spn=" + spn + "&fmi=" + fmi + "&machineSeries="+ machineSeries, {
            observe: 'response',
            responseType: 'json',
            headers: headers,
        });
    }
}

export interface J1939DtcBase {
    readonly RAWDATA: Uint8Array;
    ecuId?: number;
    spn?: number;
    fmi?: number;
    statusMask?: number;
    timestamp?: number;
}

export interface t_Dtc {
    ecuId?: number;
    spn?: number;
    fmi?: string;
    timestamp?: number;
    message?: string;
    criticality?: number; 
    occurence?: number;
    activity?: string;
    troubleshoot?: boolean;
    troubleshootPath?: any;
};

export interface ECU {
    value: number;
    viewValue: string;
    notAnOption?: boolean;
};
